const slidesContainer = document.querySelector("[data-slides]");
const buttons = document.querySelectorAll("[data-carousel-button]");
const slides = document.querySelectorAll("[data-slides] .slide");

let idx = 0;

buttons.forEach((button) => {
  button.addEventListener("click", () => {
    const offset = button.dataset.carouselButton === "next" ? 1 : -1;
    if (offset === 1) console.log("next");
    idx += offset;
    changeTarget();
  });
});

function changeTarget() {
  if (idx > slides.length - 1) idx = 0;
  else if (idx < 0) idx = slides.length - 1;

  slidesContainer.style.transform = `translateX(${-idx * 100}%)`;
}
